import { render, staticRenderFns } from "./OnValidationList.vue?vue&type=template&id=0ffee702&"
import script from "./OnValidationList.vue?vue&type=script&lang=js&"
export * from "./OnValidationList.vue?vue&type=script&lang=js&"
import style0 from "./OnValidationList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnValidationList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports